import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import TrocarSenha from './pages/TrocarSenha';
import Home from './pages/Home';
import Cultura from './pages/Cultura';
import Organograma from './pages/Organograma';
import Avisos from './pages/Avisos';
import AvisoEditor from './pages/admin/AvisoEditor';
import CentralAvisos from './pages/admin/CentralAvisos';
import AdminHub from './pages/admin/AdminHub';
import Cargos from './pages/admin/Cargos';
import Categorias from './pages/admin/Categorias';
import Quizzes from './pages/admin/Quizzes';
import Seguranca from './pages/admin/Seguranca';
import Atas from './pages/Atas';
import AtaView from './pages/AtaView';
import MinhasTarefas from './pages/MinhasTarefas';
import AtaEditor from './pages/admin/AtaEditor';
import AtaPastas from './pages/admin/AtaPastas';
import Posicoes from './pages/admin/Posicoes';
import Documentos from './pages/Documentos';
import DocumentosHall from './pages/DocumentosHall';
import DocumentoView from './pages/DocumentoView';
import DocumentoEditor from './pages/admin/DocumentoEditor';
import Academia from './pages/Academia';
import Trilha from './pages/Trilha';
import Quiz from './pages/Quiz';
import TrilhaEditor from './pages/admin/TrilhaEditor';
import QuizEditor from './pages/admin/QuizEditor';
import GestaoAcessos from './pages/admin/GestaoAcessos';
import Equipe from './pages/Equipe';
import EquipeFuncionario from './pages/EquipeFuncionario';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/trocar-senha" element={<PrivateRoute><TrocarSenha /></PrivateRoute>} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/cultura" element={<PrivateRoute><Cultura /></PrivateRoute>} />
      <Route path="/organograma" element={<PrivateRoute><Organograma /></PrivateRoute>} />
      <Route path="/avisos" element={<PrivateRoute><Avisos /></PrivateRoute>} />
      <Route path="/admin/avisos" element={<PrivateRoute><CentralAvisos /></PrivateRoute>} />
      <Route path="/admin/avisos/novo" element={<PrivateRoute><AvisoEditor /></PrivateRoute>} />
      <Route path="/admin/avisos/:id/editar" element={<PrivateRoute><AvisoEditor /></PrivateRoute>} />
      <Route path="/documentos" element={<PrivateRoute><DocumentosHall /></PrivateRoute>} />
      <Route path="/documentos/manuais" element={<PrivateRoute><Documentos /></PrivateRoute>} />
      <Route path="/documentos/:id" element={<PrivateRoute><DocumentoView /></PrivateRoute>} />
      <Route path="/admin/documentos/novo" element={<PrivateRoute><DocumentoEditor /></PrivateRoute>} />
      <Route path="/admin/documentos/:id/editar" element={<PrivateRoute><DocumentoEditor /></PrivateRoute>} />
      <Route path="/academia" element={<PrivateRoute><Academia /></PrivateRoute>} />
      <Route path="/academia/trilhas/:id" element={<PrivateRoute><Trilha /></PrivateRoute>} />
      <Route path="/academia/quiz/:quizId" element={<PrivateRoute><Quiz /></PrivateRoute>} />
      <Route path="/admin/trilhas/nova" element={<PrivateRoute><TrilhaEditor /></PrivateRoute>} />
      <Route path="/admin/trilhas/:id/editar" element={<PrivateRoute><TrilhaEditor /></PrivateRoute>} />
      <Route path="/admin/quizzes/nova" element={<PrivateRoute><QuizEditor /></PrivateRoute>} />
      <Route path="/admin/quizzes/:id/editar" element={<PrivateRoute><QuizEditor /></PrivateRoute>} />
      <Route path="/admin/acessos" element={<PrivateRoute><GestaoAcessos /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><AdminHub /></PrivateRoute>} />
      <Route path="/admin/cargos" element={<PrivateRoute><Cargos /></PrivateRoute>} />
      <Route path="/admin/organograma" element={<PrivateRoute><Posicoes /></PrivateRoute>} />
      <Route path="/admin/categorias" element={<PrivateRoute><Categorias /></PrivateRoute>} />
      <Route path="/admin/quizzes" element={<PrivateRoute><Quizzes /></PrivateRoute>} />
      <Route path="/admin/seguranca" element={<PrivateRoute><Seguranca /></PrivateRoute>} />
      <Route path="/atas" element={<PrivateRoute><Atas /></PrivateRoute>} />
      <Route path="/atas/pastas" element={<PrivateRoute><AtaPastas /></PrivateRoute>} />
      <Route path="/atas/nova" element={<PrivateRoute><AtaEditor /></PrivateRoute>} />
      <Route path="/atas/:id" element={<PrivateRoute><AtaView /></PrivateRoute>} />
      <Route path="/atas/:id/editar" element={<PrivateRoute><AtaEditor /></PrivateRoute>} />
      <Route path="/minhas-tarefas" element={<PrivateRoute><MinhasTarefas /></PrivateRoute>} />
      <Route path="/equipe" element={<PrivateRoute><Equipe /></PrivateRoute>} />
      <Route path="/equipe/:id" element={<PrivateRoute><EquipeFuncionario /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
